export enum EscrowStatus {
  ES_UNSET, // Do not use, needed because of proto3 limitations
  PENDING,
  OPEN,
  CLOSED,
  FAILED,
  TERMINATED,
}
